export enum ActionButtonType {
  Primary = "primary",
  Confirm = "confirm",
  Cancel = "cancel",
}

export enum ActionButtonSize {
  Normal = "normal",
  Small = "small",
  Smaller = "smaller",
}
